import { type ChatInputSubmitMetadata } from '@apps/web/components/phoebe_chat/chat_input';

export type AdminAgentMessageDeliveryMode = 'queue' | 'steer';

export function resolveAdminAgentMessageDeliveryMode({
    isSelectedRunBusy,
    submitMetadata,
}: {
    readonly isSelectedRunBusy: boolean;
    readonly submitMetadata?: ChatInputSubmitMetadata;
}): AdminAgentMessageDeliveryMode | undefined {
    if (!isSelectedRunBusy) {
        return undefined;
    }
    return submitMetadata?.trigger === 'keyboard_shift_enter'
        ? 'queue'
        : 'steer';
}
